<template>
  <details class="mt-3">
    <summary>{{ t("backend.e2e.voting_round_reports.show.ceremony_details") }}</summary>
    <div class="mt-3">
      <table class="table table-borderless">
        <thead>
          <tr>
            <th>
              <AVIcon icon="user" />
              {{ t("activerecord.models.e2e/trustee.one") }}
            </th>
            <th>
              <AVIcon icon="shuffle" />
              {{ t("js.result_progress.states.mixing") }}
            </th>
            <th>
              <AVIcon icon="key" />
              {{ t("js.result_progress.states.decrypting") }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="trustee in trustees">
            <td>{{ trustee.name }}</td>
            <td>
              <AVIcon
                v-if="calculateTrusteeMixingStatus(trustee, resultOrchestrator) === 'finished'"
                icon="check"
                class="text-success"
              />
              <AVIcon
                v-else-if="calculateTrusteeMixingStatus(trustee, resultOrchestrator) === 'cancelled'"
                icon="xmark"
                class="text-danger"
              />
              <AVIcon
                v-else
                icon="ellipsis"
                class="text-muted"
              />
            </td>
            <td>
              <AVIcon
                v-if="calculateTrusteeDecryptionStatus(trustee, resultOrchestrator) === 'finished'"
                icon="check"
                class="text-success"
              />
              <AVIcon
                v-else-if="calculateTrusteeDecryptionStatus(trustee, resultOrchestrator) === 'cancelled'"
                icon="times"
                class="text-danger"
              />
              <AVIcon
                v-else
                icon="ellipsis"
                class="text-muted"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <a
        class="btn btn-sm btn-link"
        :href="`../../../e2e/result_orchestrators/${resultOrchestrator.id}/download_audit_zip`"
      >
        <AVIcon icon="gavel" />
        {{ t("backend.e2e.threshold_ceremony.index.download_audit_zip") }}
      </a>
    </div>
  </details>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import {
  calculateTrusteeMixingStatus,
  calculateTrusteeDecryptionStatus,
} from "@/entrypoints/shared/trustee_status_helpers";
import type {
  PropType,
  ElectaTrustee,
  E2E,
} from "@/types";

const { t } = useI18n();

defineProps({
  trustees: {
    type: Array as PropType<Array<ElectaTrustee>>,
    required: true,
  },
  resultOrchestrator: {
    type: Object as PropType<E2E.ResultOrchestrator>,
    required: true,
  },
});
</script>
